import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { API_ENDPOINTS } from '../../config/api.config';
import { postData } from '../../utils/apiUtils';
import './EmailVerificationModal.css';

const EmailVerificationModal = ({ show, onHide, onSuccess, planType, billingOption }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Clear email input and error when modal is shown after an error
  useEffect(() => {
    if (show) {
      // Clear previous errors and email when showing the modal
      setError('');
      setEmail('');
    }
  }, [show]);
  
  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setIsLoading(true);
    
    try {
      // Proceed with payment process
      onSuccess(email, planType, billingOption);
    } catch (error) {
      console.error('Email verification error:', error);
      
      // This catch block may not execute if onSuccess redirects
      setError('An error occurred while processing your request. Please try again.');
      // Clear the email field on error
      setEmail('');
    } finally {
      setIsLoading(false);
    }
  };
  
  if (!show) return null;
  
  // Use a custom modal implementation instead of Bootstrap's Modal component
  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-container">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">Enter Your Email</h5>
            <button 
              type="button" 
              className="custom-modal-close" 
              onClick={onHide}
              aria-label="Close"
            >×</button>
          </div>
          <div className="custom-modal-body">
            <p>
              {planType === 'trial' 
                ? 'Please enter your email address to continue with your free trial.' 
                : 'Please enter your email address to continue with your purchase.'}
            </p>
            
            <div className="email-requirement-notice">
              <strong>Important:</strong> Please check your spam/junk folder if you don't receive our email within a few minutes.
            </div>
            
            {error && (
              <div className="custom-alert-danger">{error}</div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={handleInputChange}
                  placeholder="Enter your email address"
                  required
                  autoFocus
                />
              </div>
              
              <div className="d-flex justify-content-end mt-4">
                <button 
                  type="button"
                  className="btn-cancel"
                  onClick={onHide}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button 
                  type="submit"
                  className="btn-primary"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner"></span>
                      Processing...
                    </>
                  ) : (
                    planType === 'trial' ? 'Continue to Trial' : 'Continue to Payment'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationModal; 